import {combineReducers} from "@reduxjs/toolkit";
import {authReducer} from '~/reduxs/Auth/authSlice';
import {customerReducer} from '~/reduxs/Customer/customerSlice';
import {supplierReducer} from '~/reduxs/Supplier/supplierSlice';
import {attributeReducer} from '~/reduxs/Attribute/attributeSlice';
import {productCategoryReducer} from '~/reduxs/ProductCategory/productCategorySlice';
import {productReducer} from '~/reduxs/Product/productSlice';
import {userReducer} from '~/reduxs/User/userSlice';
import {purchaseOrderReducer} from '~/reduxs/PurchaseOrder/purchaseOrderSlice';
import {posReducer} from '~/reduxs/Pos/posSlice';
import {orderReducer} from '~/reduxs/Order/orderSlice';

const rootReducer = combineReducers({
	auth  : authReducer,
	customer: customerReducer,
	supplier: supplierReducer,
	attribute: attributeReducer,
	productCategory: productCategoryReducer,
	product: productReducer,
	user: userReducer,
	purchaseOrder: purchaseOrderReducer,
	pos: posReducer,
	order: orderReducer,
});

export default rootReducer;